export { ChemicalsList } from './ChemicalsList.component';
